"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ArrowsDiagonalIn16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1234 5.07656L14.1657 7.0166L8.669 6.85645L8.50886 1.35974L10.4489 1.4021L10.5205 3.5908L13.99 0.121365L15.4041 1.53553L11.9346 5.00499L14.1234 5.07656ZM1.05837 10.7926L1.01601 8.85258L6.51272 9.01272L6.67286 14.5094L4.73283 14.4671L4.66126 12.2784L1.53551 15.4041L0.121338 13.9899L3.24711 10.8642L1.05837 10.7926Z", fill: "black" }));
}
function ArrowsDiagonalIn16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ArrowsDiagonalIn16Svg, Object.assign({}, svgProps)));
}
exports.default = ArrowsDiagonalIn16;
//# sourceMappingURL=ArrowsDiagonalIn16.js.map